import {NgIf} from '@angular/common';
import {Component, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {NbTooltipModule} from '@nebular/theme';
import {BaseComponent, ProductCustomer} from 'compob2b-libs';
import {translations} from '../../../../environments/translations.ru';
import {TuiIcon} from '@taiga-ui/core'

@Component({
  selector: 'app-code-icons',
  imports: [
    RouterLink,
    NbTooltipModule,
    NgIf,
    TuiIcon
  ],
  templateUrl: './code-icons.component.html',
  styleUrl: './code-icons.component.scss'
})
export class CodeIconsComponent extends BaseComponent {
  analogTerm = translations.analog;
  relatedTerm = translations.related;

  @Input() row: ProductCustomer;
}
